<template>
  <!-- Tag necesario para vuetify -->
  <!--  #f8f9f9 // #f2f5f8 // #f5f6f6 -->
  <v-app style="background-color: #fffff">

    <!-- Top Menu -->
    <app-navbar></app-navbar>

    <!-- Muestra las vistas plasmadas en el Router -->
    <app-router></app-router>

    <!-- Footer Layout-->
    <app-footer></app-footer>

  </v-app>
</template>

<script>

  //Components Layouts
  import Navbar   from './theme/layouts/TheNavbar.vue'
  import View     from './theme/layouts/TheView.vue'
  import Footer   from './theme/layouts/TheFooter.vue'

export default {
  name: 'App',
  components:  {
    'app-navbar': Navbar,
    'app-router': View,
    'app-footer': Footer,
  },
  data () {
      return {

      }
  },
};
</script>
